import React from 'react';

import {PremiumFeatureTooltip} from '../../../../util/accounts/pricing';

type SettingsHeaderProps = {
  title: string;
  description: string | React.ReactElement;
  isPremiumFeatureDisabled?: boolean;
};

export const SettingsHeader = ({
  title,
  description,
  isPremiumFeatureDisabled,
}: SettingsHeaderProps) => {
  return (
    <div className="flex flex-col">
      <div className="flex items-center">
        <h2 className="text-xl font-semibold text-moon-900 dark:text-moon-100">
          {title}
        </h2>
        {isPremiumFeatureDisabled != null && (
          <PremiumFeatureTooltip
            isPremiumFeatureDisabled={isPremiumFeatureDisabled}
          />
        )}
      </div>
      <p className="text-wb-text-tertiary">{description}</p>
    </div>
  );
};
